/* eslint-disable */
// /src/auth-kit/guards/RequireAnon.jsx
import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

// 로컬 세션: dhm.session 사용
function hasSession() {
    try {
        const raw = localStorage.getItem("dhm.session");
        if (!raw) return false;
        const s = JSON.parse(raw);
        return !!s && !!s.token;
    } catch { return false; }
}

/**
 * 비로그인 전용 가드
 * - 세션이 있으면 /home 으로 즉시 이동
 * - 없으면 children 랜더링(로그인/가입 페이지 접근 허용)
 */
export default function RequireAnon({ children }) {
    const loc = useLocation();
    const [authed, setAuthed] = useState(false);
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        setAuthed(hasSession());
        setChecked(true);
    }, [loc.key]);

    if (!checked) return null; // 아주 짧은 초기 체크 대기

    if (authed) {
        // 뒤로가기 시 로그인 화면이 다시 안 보이도록 replace
        return <Navigate to="/home" replace />;
    }
    return children;
}
